// extracted by mini-css-extract-plugin
module.exports = {"block-embedded-entry-link":"BlockEntryLink_block-embedded-entry-link__Kc5M9","block-embedded-entry-link-printable":"BlockEntryLink_block-embedded-entry-link-printable__2t2AT"};